exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart[data-v-f0aa5bb4]{min-height:420px;width:100%;background:transparent}", ""]);

// exports
